export const ANTENNA_TITLE = 'claim.declaration.external_damages.form.antenna.question.title';
export const ANTENNA_COUNT_LABEL = 'claim.declaration.external_damages.form.antenna.count';
